export default "__VITE_ASSET__B8bVsNZ9__"